import { gql } from 'graphql-tag';

export const RecommendedWorkersDocument = gql`
  query recommendedWorkers($jobId: ID!) {
    recommendedWorkers(jobId: $jobId) {
      recommendations {
        explanation {
          availabilityOverlap
          overallServiceCoverage
        }
        worker {
          about
          combinedFeedback
          deliveredHourGroup
          distanceAway
          normalizedType
          loyaltyName
          rates {
            rateCents
            rateName
          }
          ratings {
            id
          }
          response {
            time
            veryResponsive
          }
          statutoryDeclarationStatus
          user {
            avatar {
              big
              small
            }
            approved
            displayName
            firstName
            id
            normalizedType
            permalink
            postcode
            truncatedName
          }
        }
      }
    }
  }
`;
